import { checkHashStore } from '../../../store/checkHashStore';
import { userInfoStore } from '../../../store/userInfoStore';
import { coinFlipGameConnection } from '../coinFlipConnection';
import { reportStateStatuses, ValidationType } from '../../../core/constants/validationType';
import { notificationStore } from '../../../store/notificationStore';
import { coinFlipBetsStore } from '../coinFlipStore/betStore';
import { userSettingsStore } from '../../../store/userSettingsStore';
import {
  COIN_FLIP_ANIMATION_DURATION,
  COIN_FLIP_ANIMATION_DURATION_TURBO,
} from '../coinFlipCore/constants';
import { betHistoryStore } from '../../../store/betHistoryStore';
import { TranslationKeys } from '../../../core/constants/translationKeys';
import { soundService } from '../../../services/baseSoundService/soundService';
import { CoinFlipSoundsName } from '../coinFlipCore/constants/sounds';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';
import { coinFlipDrawerService } from './gameDrawerService';
import { freeBetStore } from '../../../store/freeBetStore';

class CoinFlipGameService {
  onGetInitialStateResult({ additionalInfo, spinInfo, nextOdd }) {
    coinFlipBetsStore.resetStore();
    if (additionalInfo) {
      checkHashStore.setLastRoundInfo(additionalInfo);
      checkHashStore.setLastRoundResult({
        id: additionalInfo.id,
        odd: additionalInfo.odd,
        time: additionalInfo.date,
        spinMarkets: [additionalInfo.marketType],
      });
    }
    coinFlipBetsStore.setNextOdd(nextOdd || null);
    if (spinInfo) {
      const { odd, amount, winAmount, spinData } = spinInfo;
      coinFlipBetsStore.setIsAllowSendBet(false);
      coinFlipBetsStore.setIsDoSpinStart(true);
      coinFlipBetsStore.setOdd(odd);
      coinFlipBetsStore.setIsBetsClosed(false);
      coinFlipBetsStore.setIsDoSpinResult(true);
      userInfoStore.setBetAmount(amount);
      coinFlipBetsStore.setCashOutWin(winAmount);
      coinFlipBetsStore.setLastStepResult(spinData.marketType);
      if (spinInfo.spinData.odd) {
        coinFlipBetsStore.updateLastResults({
          marketType: spinData.marketType,
          odd: odd,
        });
      }
      if (spinInfo.winAmount) {
        coinFlipBetsStore.setIsAllowCashOut(true);
      }
    } else {
      coinFlipBetsStore.setOdd(nextOdd || null);
    }
    checkHashStore.setNextHashTextInfo(TranslationKeys.NextFlipSide);
  }

  doSpin() {
    soundService.play(CoinFlipSoundsName.bet);
    if (coinFlipBetsStore.isAllowSendBet) {
      mainGameConnection.doSpin();
    }
    coinFlipBetsStore.setIsAllowSendBet(false);
  }

  handleDoSpinResult({ responseCode, balance, nextOdd }) {
    if (responseCode === ValidationType.Success) {
      if (!freeBetStore.currentFreeBet) {
        userInfoStore.setUserBalance(balance);
      }
      coinFlipBetsStore.setIsDoSpinStart(true);
      coinFlipBetsStore.setIsDoSpinResult(true);
      coinFlipBetsStore.setNextOdd(nextOdd);
    } else {
      coinFlipBetsStore.setIsDoSpinResult(false);
      coinFlipBetsStore.setIsDoSpinStart(false);
      notificationStore.setNotification(responseCode);
      coinFlipBetsStore.setIsAllowSendBet(true);
    }
  }

  handleReportStateResult({
    responseCode,
    winAmount,
    marketType,
    odd,
    nextOdd,
    freebetInfo,
    hash,
    key,
    salt,
    spinId,
    status,
    additionalInfo,
  }) {
    if (responseCode === ValidationType.Success) {
      coinFlipDrawerService.handleWinCoin(marketType, winAmount);
      if (freebetInfo !== null) {
        freeBetStore.updateCurrentFreeBet(freebetInfo);
      }
      coinFlipBetsStore.setOdd(odd);
      soundService.play(CoinFlipSoundsName.select);
      !userSettingsStore.isTurboOn && soundService.play(CoinFlipSoundsName.flipping);
      checkHashStore.setNextRoundHash(additionalInfo.hash);
      checkHashStore.setLastRoundInfo({ salt, key, hash });
      checkHashStore.setLastRoundResult({
        spinMarkets: [marketType],
        id: spinId,
      });
      this.updateGameStateAfterAnimation({ winAmount, marketType, odd, nextOdd });
      if (status === reportStateStatuses.win) {
        setTimeout(() => {
          coinFlipBetsStore.setWinAmount(winAmount);
          soundService.play(CoinFlipSoundsName.win);
          coinFlipBetsStore.setWinOdd(odd);
          betHistoryStore.getLastBet();
          setTimeout(() => {
            this.resetGameData(true);
          }, 1500);
        }, 1000);
      }
    } else {
      notificationStore.setNotification(responseCode);
    }
  }

  updateGameStateAfterAnimation({ winAmount, marketType, odd, nextOdd }) {
    setTimeout(
      () => {
        coinFlipBetsStore.setCashOutWin(winAmount);
        coinFlipBetsStore.setNextOdd(nextOdd);
        coinFlipBetsStore.setIsStartAnimation(false);
        if (!odd) {
          // soundService.play(CoinFlipSoundsName.lose);
          coinFlipBetsStore.setLastResults([]);
          betHistoryStore.getLastBet();
        } else {
          // soundService.play(CoinFlipSoundsName.rightDecision);
          coinFlipBetsStore.updateLastResults({ marketType, odd });
        }
        if (winAmount) {
          coinFlipBetsStore.setIsBetsClosed(false);
          coinFlipBetsStore.setIsAllowCashOut(true);
        } else {
          setTimeout(() => {
            this.resetGameData();
          }, 1000);
        }
      },
      userSettingsStore.isTurboOn
        ? COIN_FLIP_ANIMATION_DURATION_TURBO
        : COIN_FLIP_ANIMATION_DURATION
    );
  }

  sendCashOut() {
    if (coinFlipBetsStore.isAllowCashOut && coinFlipBetsStore.cashOutWin) {
      coinFlipBetsStore.setIsAllowCashOut(false);
      coinFlipGameConnection.sendCashOut();
    }
  }

  handleCashOutResult({
    responseCode,
    freebetInfo,
    winAmount,
    odd,
    key,
    salt,
    spinId,
    hash,
    additionalInfo,
  }) {
    if (responseCode === ValidationType.Success) {
      if (freebetInfo !== null) {
        freeBetStore.updateCurrentFreeBet(freebetInfo);
      }
      coinFlipBetsStore.setWinAmount(winAmount);
      soundService.play(CoinFlipSoundsName.win);
      coinFlipBetsStore.setWinOdd(odd);
      coinFlipBetsStore.setOdd(odd);
      checkHashStore.setLastRoundInfo({ salt, key, hash });
      checkHashStore.setLastRoundResult({ id: spinId });
      checkHashStore.setNextRoundHash(additionalInfo.hash);
      betHistoryStore.getLastBet();
      setTimeout(() => {
        this.resetGameData(true);
      }, 1500);
    } else {
      notificationStore.setNotification(responseCode);
      coinFlipBetsStore.setIsAllowCashOut(true);
    }
  }

  sendResultReport(marketType) {
    if (coinFlipBetsStore.isBetsClosed) {
      return;
    }
    const model = {
      marketType,
    };
    coinFlipBetsStore.setIsBetsClosed(true);
    coinFlipGameConnection.sendResultReport(model);
  }

  resetGameData() {
    coinFlipBetsStore.setIsAllowSendBet(true);
    coinFlipBetsStore.setLastStepResult(null);
    coinFlipBetsStore.setIsBetsClosed(false);
    coinFlipBetsStore.setCashOutWin(null);
    coinFlipBetsStore.setIsAllowCashOut(false);
    coinFlipBetsStore.setWinOdd(null);
    coinFlipBetsStore.setWinAmount(null);
    coinFlipBetsStore.setIsDoSpinResult(false);
    coinFlipDrawerService.playCoinIdle();
    coinFlipBetsStore.setIsDoSpinStart(false);
    coinFlipBetsStore.setIsStartAnimation(false);
    coinFlipBetsStore.setLastResults([]);
    coinFlipBetsStore.setNextOdd(null);
    userInfoStore.getBalance();
  }
}

export const coinFlipGameService = new CoinFlipGameService();
